import { useTranslation } from 'react-i18next'
import { ShowDialogProps } from 'src/show-dialog'
import { DocumentCategoryForm } from 'src/screens/customer/document-categories/DocumentCategoryForm'
import {
  invalidateCustomerDocumentCategoryCache,
  useAddCustomerDocumentCategory,
} from 'src/api/customer-document-category'
import { toast } from 'react-toastify'
import { useCallback } from 'react'

interface CreateCustomerDocumentCategoryDialogProps extends ShowDialogProps {
  customerId: string
}
export const CreateCustomerDocumentCategoryDialog: React.FC<CreateCustomerDocumentCategoryDialogProps> = ({
  pop,
  customerId,
}) => {
  const { t: translate } = useTranslation(['documentcategory', 'common'])

  const mutation = useAddCustomerDocumentCategory(customerId)
  const onSubmit = useCallback(
    async form => {
      await mutation.mutateAsync(form, {
        onSuccess: () => {
          toast.success(translate('successfullyAdded', { ns: 'common-api-message' }))
          invalidateCustomerDocumentCategoryCache.getCustomerDocumentCategories(customerId)
          invalidateCustomerDocumentCategoryCache.getCustomerAndAdminDocumentCategories(customerId)
          pop(true)
        },
        onError: error => {
          if (error && error['data'] === 'DocumentCategoryAlreadyExists') {
            toast.warning(translate('documentCategoryAlreadyExists', { ns: 'document-category' }))
          } else {
            toast.error(translate('CannotAddDocumentCategory', { ns: 'document-category' }))
          }
        },
      })
    },
    [mutation, translate, customerId, pop],
  )

  return (
    <DocumentCategoryForm
      onSubmit={onSubmit}
      onCancel={() => pop()}
      title={translate('addDocumentCategory', { ns: 'document-category' })}
    />
  )
}
